import { z } from 'zod';

const ResolveIssueFormSchema = z.object({
    resolveReason: z
        .string({
            required_error: 'Notes are required',
        })
        .min(1, 'Notes cannot be empty'),
});

type ResolveIssueFormValues = z.infer<typeof ResolveIssueFormSchema>;

export { ResolveIssueFormSchema, ResolveIssueFormValues };
